import { config } from '@fortawesome/fontawesome-svg-core';
import { useI18n as useI18nExcalibur } from '@clicksign/excalibur/composables';
import { registerIcons } from '@clicksign/ds-icons';

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false;

function setLocale(locale: string) {
  if (!locale) return;
  const { setLocale: setExcaliburLocale } = useI18nExcalibur();

  setExcaliburLocale(locale);
}

export default defineNuxtPlugin((nuxtApp) => {
  const { locale } = nuxtApp.$i18n as ReturnType<ReturnType<typeof useI18n>>;

  setLocale(locale.value);

  registerIcons();

  // eslint-disable-next-line no-console
  console.debug('Excalibur plugin loaded');
});
